// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));


export const getSpecSakit = createAsyncThunk(
    "SakitTransaksi/getSpecSakit",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/sakitSpec',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
// API

export const getSakitTransaksi = createAsyncThunk(
    "sakitTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        const config = {
            headers: {'Authorization': `Bearer ` + user.Token},
            params: {"start": start, "count": count, "search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+'hrd/sakit',
                config,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getSakitReport = createAsyncThunk(
    "getSakitReport/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/sakit/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getSakitReportDetail = createAsyncThunk(
    "getSakitReportDetail/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/sakit/lap/detail',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertSakitTransaksi = createAsyncThunk(
    "sakitTransaksi/insert",
    async (object, thunkAPI) => {
        let formData = new FormData();
        formData.append("FileSuratDokter", object.FileSuratDokter);
        formData.append("JenisPerawatan", object.JenisPerawatan);
        formData.append("NamaDokter", object.NamaDokter);
        formData.append("NamaRS", object.NamaRS);
        formData.append("Nik", object.Nik);
        formData.append("PenyakitID", object.PenyakitID);
        formData.append("TanggalSakit", object.TanggalSakit.toISOString());
        formData.append("TanggalSembuh", object.TanggalSembuh.toISOString());


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/sakit',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateSakitTransaksi = createAsyncThunk(
    "sakitTransaksi/update",
    async ({
               TSakitID,
               Nik,
               JenisSakit,
               KeperluanSakit,
               Pengganti,
               TanggalMulai,
               TanggalAkhir,
               Tiket,
               JamAwal,
               JamAkhir
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("TSakitID", TSakitID);
        formData.append("Nik", Nik);
        formData.append("JenisSakit", JenisSakit);
        formData.append("KeperluanSakit", KeperluanSakit);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("Tiket", Tiket);
        formData.append("JamAwal", JamAwal);
        formData.append("JamAkhir", JamAkhir);

        try {
            const response = await axios.post(
                'https://api.ranjisams.com/hrd/sakit',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetSakitSlice = createAsyncThunk(
    "resetSakitSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
export const resetSakitDetailSlice = createAsyncThunk(
    "resetSakitDetailSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecSakitData: [],
    isSpecSakitFetching: false,
    isSpecSakitSuccess: false,
    isSpecSakitError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false,
    isGetReportDetail: false,

};


//SLICES
export const sakitTransaksiSlice = createSlice({
    name: "sakitTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET


        [resetSakitSlice.fulfilled]: (state, {payload}) => {
            state = initialState
            return state;
        },


        [getSakitReport.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.isGetReport = true;
            state.message = payload.message;
            return state;
        },
        [getSakitReport.rejected]: (state, {payload}) => {
            state.isGetReport = false;
        },
        [getSakitReport.pending]: (state) => {
            state.isGetReport = false;
        },

        [getSakitReportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.reportDetail = payload.data;
                state.message = payload.message;
            }
            state.isGetReportDetail = true;
            return state;
        },
        [getSakitReportDetail.rejected]: (state, {payload}) => {
            state.isGetReportDetail = false;
        },
        [getSakitReportDetail.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [resetSakitDetailSlice.pending]: (state) => {
            state.isGetReportDetail = false;
        },


        [getSakitTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getSakitTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getSakitTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertSakitTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertSakitTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertSakitTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateSakitTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateSakitTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateSakitTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
        [getSpecSakit.fulfilled]: (state, {payload}) => {
            state.SpecSakitData = payload.data[0];
            state.isSpecSakitSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecSakit.rejected]: (state, {payload}) => {
            state.isSpecSakitFetching = false;
        },
        [getSpecSakit.pending]: (state) => {
            state.isSpecSakitFetching = false;
        },

    },
});


export const sakitTransaksiSelector = (state) => state.sakitTransaksi;
